export function formatDateString(dateStr){
    if(dateStr) {
        const date = new Date(dateStr);
        console.log('date string', date)
        const formattedDate = new Intl.DateTimeFormat('fr-FR', { day: 'numeric', month: 'numeric', year: 'numeric' }).format(date);
        const formattedTime = new Intl.DateTimeFormat('fr-FR', { hour: '2-digit', minute: '2-digit'}).format(date);

        return `${formattedDate} à ${formattedTime}`
    }
}